import * as i0 from '@angular/core';
import { Component, Injectable, Pipe, ViewEncapsulation, Input, ViewChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i3 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1 from '@angular/forms';
import { FormsModule } from '@angular/forms';
import * as i6 from '@angular/cdk/scrolling';
import { CdkVirtualScrollViewport, ScrollingModule } from '@angular/cdk/scrolling';
import { BehaviorSubject, Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Mutex } from 'async-mutex';
import * as i2 from '@niceltd/cxone-components/checkbox';
import { CheckboxModule } from '@niceltd/cxone-components/checkbox';
import * as i1$1 from '@angular/platform-browser';
import * as i2$1 from '@niceltd/cxone-components/translation';
import { TranslationModule } from '@niceltd/cxone-components/translation';
import * as i5 from '@niceltd/cxone-components/grid';
import { GridModule } from '@niceltd/cxone-components/grid';
import * as i7 from '@niceltd/cxone-components/text-input';
import { TextInputModule } from '@niceltd/cxone-components/text-input';
import * as i8 from '@niceltd/cxone-components/multiselect-dropdown';
import { MultiselectDropdownModule } from '@niceltd/cxone-components/multiselect-dropdown';
import * as i9 from '@niceltd/cxone-components/singleselect-dropdown';
import { SingleselectDropdownModule } from '@niceltd/cxone-components/singleselect-dropdown';
import * as i10 from '@niceltd/cxone-components/omnibar';
import { OmnibarModule } from '@niceltd/cxone-components/omnibar';
import * as i11 from '@niceltd/cxone-components/overflow-tooltip';
import { OverflowTooltipModule } from '@niceltd/cxone-components/overflow-tooltip';
import * as i12 from '@niceltd/cxone-components/selected-tags';
import { SelectedTagsModule } from '@niceltd/cxone-components/selected-tags';
import * as i13 from '@niceltd/cxone-components/tabs';
import { TabsModule } from '@niceltd/cxone-components/tabs';
import * as i14 from 'ngx-bootstrap/popover';
import { PopoverModule } from 'ngx-bootstrap/popover';
import * as i15 from '@niceltd/cxone-components/spinner';
import { SpinnerModule } from '@niceltd/cxone-components/spinner';
import * as i2$2 from 'angular-i18next';
import { I18NextModule } from 'angular-i18next';
function AddEntityComponent_div_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 44);
    i0.ɵɵelement(1, "div", 45);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.entity.icon, i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_span_11_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" (", i0.ɵɵpipeBind1(2, 2, "cxone-domain-components.addEntity.viewing"), " ", ctx_r1.gridApi.getDisplayedRowCount(), ")");
  }
}
function AddEntityComponent_div_13_span_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r28 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" (", ctx_r28.filterOperation, ")");
  }
}
function AddEntityComponent_div_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r30 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 46)(1, "a", 22);
    i0.ɵɵlistener("click", function AddEntityComponent_div_13_Template_a_click_1_listener() {
      i0.ɵɵrestoreView(_r30);
      const ctx_r29 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r29.selectAll());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵtemplate(4, AddEntityComponent_div_13_span_4_Template, 2, 1, "span", 8);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, "cxone-domain-components.addEntity.selectAll"));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", (ctx_r2.filterOperation == null ? null : ctx_r2.filterOperation.length) > 0);
  }
}
function AddEntityComponent_div_14_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate2(" ", ctx_r3.multiSelRows.length, " ", i0.ɵɵpipeBind1(2, 2, "cxone-domain-components.addEntity.selected"), " ");
  }
}
function AddEntityComponent_div_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r32 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 47);
    i0.ɵɵlistener("click", function AddEntityComponent_div_18_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r32);
      const ctx_r31 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r31.clearSearchField());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r4.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml)("hidden", !ctx_r4.searchQuery || (ctx_r4.searchQuery == null ? null : ctx_r4.searchQuery.length) === 0);
  }
}
function AddEntityComponent_div_19_Template(rf, ctx) {
  if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 48);
    i0.ɵɵlistener("click", function AddEntityComponent_div_19_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r34);
      const ctx_r33 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r33.onSearchQueryChange(ctx_r33.searchQuery));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r5.addEntityService.getIcon("icon-search"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_div_20_Template(rf, ctx) {
  if (rf & 1) {
    const _r36 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 49)(1, "div", 50);
    i0.ɵɵlistener("click", function AddEntityComponent_div_20_Template_div_click_1_listener() {
      i0.ɵɵrestoreView(_r36);
      const ctx_r35 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r35.toggleFilters());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r6.addEntityService.getIcon("icon-filter"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_div_21_Template(rf, ctx) {
  if (rf & 1) {
    const _r38 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 51)(1, "cxone-selected-tags", 52);
    i0.ɵɵlistener("tagDeleted", function AddEntityComponent_div_21_Template_cxone_selected_tags_tagDeleted_1_listener($event) {
      i0.ɵɵrestoreView(_r38);
      const ctx_r37 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r37.onTagDeleted($event));
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("tagsSource", ctx_r7.selectedTags)("removable", true);
  }
}
function AddEntityComponent_div_22_Template(rf, ctx) {
  if (rf & 1) {
    const _r40 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 53)(1, "button", 54);
    i0.ɵɵlistener("click", function AddEntityComponent_div_22_Template_button_click_1_listener() {
      i0.ɵɵrestoreView(_r40);
      const ctx_r39 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r39.moveSelected());
    });
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r8 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("disabled", (ctx_r8.multiSelRows == null ? null : ctx_r8.multiSelRows.length) === 0);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 2, "cxone-domain-components.addEntity.move"), " ");
  }
}
function AddEntityComponent_div_25_Template(rf, ctx) {
  if (rf & 1) {
    const _r43 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 55);
    i0.ɵɵelement(1, "label", 56);
    i0.ɵɵelementStart(2, "cxone-multiselect-dropdown", 57);
    i0.ɵɵtwoWayListener("ngModelChange", function AddEntityComponent_div_25_Template_cxone_multiselect_dropdown_ngModelChange_2_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r43);
      const filter_r41 = restoredCtx.$implicit;
      const ctx_r42 = i0.ɵɵnextContext();
      i0.ɵɵtwoWayBindingSet(ctx_r42.filterOptionsChosen[filter_r41.id], $event) || (ctx_r42.filterOptionsChosen[filter_r41.id] = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function AddEntityComponent_div_25_Template_cxone_multiselect_dropdown_ngModelChange_2_listener() {
      i0.ɵɵrestoreView(_r43);
      const ctx_r44 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r44.onFiltersSelectionChange());
    })("onServerSideSearch", function AddEntityComponent_div_25_Template_cxone_multiselect_dropdown_onServerSideSearch_2_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r43);
      const filter_r41 = restoredCtx.$implicit;
      return i0.ɵɵresetView(filter_r41.onSearch($event));
    })("onLoadData", function AddEntityComponent_div_25_Template_cxone_multiselect_dropdown_onLoadData_2_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r43);
      const filter_r41 = restoredCtx.$implicit;
      return i0.ɵɵresetView(filter_r41.populateData());
    });
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const filter_r41 = ctx.$implicit;
    const ctx_r9 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", filter_r41.label);
    i0.ɵɵadvance();
    i0.ɵɵtwoWayProperty("ngModel", ctx_r9.filterOptionsChosen[filter_r41.id]);
    i0.ɵɵproperty("options", filter_r41.items)("search", filter_r41.searchable)("bulkOperations", filter_r41.bulkOperations)("placeholder", filter_r41.placeholder)("sortKey", filter_r41.sortKey)("sortOrder", filter_r41.sortOrder)("maxSelectionLimit", filter_r41.maxSelectionLimit)("maxItemsToDisplay", filter_r41.maxItemsToDisplay)("enableInfiniteScroll", filter_r41.enableInfiniteScroll)("serverSideSearch", filter_r41.serverSideOptions);
  }
}
function AddEntityComponent_div_45_Template(rf, ctx) {
  if (rf & 1) {
    const _r48 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵlistener("click", function AddEntityComponent_div_45_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r48);
      i0.ɵɵnextContext();
      const _r10 = i0.ɵɵreference(42);
      return i0.ɵɵresetView(_r10.modelValue = "");
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r11 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r11.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_div_46_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 59);
  }
  if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r12.addEntityService.getIcon("icon-search"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_ul_50_li_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 68);
  }
  if (rf & 2) {
    const entityRow_r50 = i0.ɵɵnextContext().$implicit;
    const ctx_r51 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerText", entityRow_r50[ctx_r51.entity.selectedEntitySubtitleKey]);
  }
}
function AddEntityComponent_ul_50_li_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r54 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 62)(1, "div", 63);
    i0.ɵɵelement(2, "div", 64);
    i0.ɵɵtemplate(3, AddEntityComponent_ul_50_li_1_div_3_Template, 1, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 66);
    i0.ɵɵlistener("click", function AddEntityComponent_ul_50_li_1_Template_div_click_4_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r54);
      const entityRow_r50 = restoredCtx.$implicit;
      const ctx_r53 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r53.removeSelectedEntity(entityRow_r50));
    });
    i0.ɵɵelement(5, "div", 67);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const entityRow_r50 = ctx.$implicit;
    const ctx_r49 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", entityRow_r50[ctx_r49.entity.selectedEntityTitleKey]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r49.entity.selectedEntitySubtitleKey);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r49.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_ul_50_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "ul", 60);
    i0.ɵɵtemplate(1, AddEntityComponent_ul_50_li_1_Template, 6, 3, "li", 61);
    i0.ɵɵpipe(2, "searchFilter");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r13 = i0.ɵɵnextContext();
    const _r10 = i0.ɵɵreference(42);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind3(2, 1, ctx_r13.selectedEntities, _r10.modelValue, ctx_r13.entity.searchFieldKey));
  }
}
function AddEntityComponent_div_51_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelement(1, "span", 70);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r14 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", ctx_r14.entity.noEntitySelectedText);
  }
}
function AddEntityComponent_div_52_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelement(1, "cxone-spinner", 72);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r15 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSpinner", ctx_r15.removeAllSelectedInProgress);
  }
}
function AddEntityComponent_div_61_Template(rf, ctx) {
  if (rf & 1) {
    const _r56 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58);
    i0.ɵɵlistener("click", function AddEntityComponent_div_61_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r56);
      const ctx_r55 = i0.ɵɵnextContext();
      const _r16 = i0.ɵɵreference(58);
      _r16.modelValue = "";
      return i0.ɵɵresetView(ctx_r55.clearAddedSearchQuery());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r17 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r17.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_div_62_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 59);
  }
  if (rf & 2) {
    const ctx_r18 = i0.ɵɵnextContext();
    i0.ɵɵproperty("innerHTML", ctx_r18.addEntityService.getIcon("icon-search"), i0.ɵɵsanitizeHtml);
  }
}
const _c0 = a0 => ({
  "disabled": a0
});
function AddEntityComponent_a_63_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "a", 73, 74);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r57 = i0.ɵɵreference(1);
    const ctx_r19 = i0.ɵɵnextContext();
    const _r27 = i0.ɵɵreference(71);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c0, ctx_r19.totalAddedEntities === 0))("popover", _r27)("adaptivePosition", true)("outsideClick", true)("popoverContext", ctx_r19.getRemoveAllPopoverContext(_r57));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(3, 6, "cxone-domain-components.addEntity.removeAll"), " ");
  }
}
function AddEntityComponent_a_64_Template(rf, ctx) {
  if (rf & 1) {
    const _r59 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 33);
    i0.ɵɵlistener("click", function AddEntityComponent_a_64_Template_a_click_0_listener() {
      i0.ɵɵrestoreView(_r59);
      const ctx_r58 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r58.removeAllAdded());
    });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r20 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(4, _c0, ctx_r20.totalAddedEntities === 0));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, "cxone-domain-components.addEntity.removeAll"), " ");
  }
}
function AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 68);
  }
  if (rf & 2) {
    const entityRow_r61 = i0.ɵɵnextContext().$implicit;
    const ctx_r62 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("innerText", entityRow_r61[ctx_r62.entity.selectedEntitySubtitleKey]);
  }
}
function AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r68 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 66);
    i0.ɵɵlistener("click", function AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_4_Template_div_click_0_listener() {
      i0.ɵɵrestoreView(_r68);
      const entityRow_r61 = i0.ɵɵnextContext().$implicit;
      const ctx_r66 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r66.removeAddedEntity(entityRow_r61));
    });
    i0.ɵɵelement(1, "div", 67);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r63 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r63.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 78, 74);
    i0.ɵɵelement(2, "div", 67);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const _r69 = i0.ɵɵreference(1);
    const entityRow_r61 = i0.ɵɵnextContext().$implicit;
    const ctx_r64 = i0.ɵɵnextContext(2);
    const _r25 = i0.ɵɵreference(69);
    i0.ɵɵproperty("popover", _r25)("outsideClick", true)("popoverContext", ctx_r64.getPopoverContext(entityRow_r61, _r69))("adaptivePosition", true);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerHTML", ctx_r64.addEntityService.getIcon("icon-close"), i0.ɵɵsanitizeHtml);
  }
}
function AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "li", 62)(1, "div", 63);
    i0.ɵɵelement(2, "div", 64);
    i0.ɵɵtemplate(3, AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_3_Template, 1, 1, "div", 65);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_4_Template, 2, 1, "div", 76)(5, AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_div_5_Template, 3, 5, "div", 77);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const entityRow_r61 = ctx.$implicit;
    const ctx_r60 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("innerText", entityRow_r61[ctx_r60.entity.selectedEntityTitleKey]);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r60.entity.selectedEntitySubtitleKey);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r60.entity.parent);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r60.entity.parent);
  }
}
function AddEntityComponent_cdk_virtual_scroll_viewport_65_Template(rf, ctx) {
  if (rf & 1) {
    const _r72 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "cdk-virtual-scroll-viewport", 75);
    i0.ɵɵlistener("scrolledIndexChange", function AddEntityComponent_cdk_virtual_scroll_viewport_65_Template_cdk_virtual_scroll_viewport_scrolledIndexChange_0_listener($event) {
      i0.ɵɵrestoreView(_r72);
      const ctx_r71 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r71.onScroll($event));
    });
    i0.ɵɵtemplate(1, AddEntityComponent_cdk_virtual_scroll_viewport_65_li_1_Template, 6, 4, "li", 61);
    i0.ɵɵpipe(2, "async");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r21 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", i0.ɵɵpipeBind1(2, 1, ctx_r21.addedEntitiesData));
  }
}
function AddEntityComponent_div_66_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 69);
    i0.ɵɵelement(1, "span", 70);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r22 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerText", ctx_r22.entity.noEntityAddedText);
  }
}
function AddEntityComponent_div_67_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 71);
    i0.ɵɵelement(1, "cxone-spinner", 72);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r23 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("isSpinner", ctx_r23.removeAllAddedInProgress);
  }
}
function AddEntityComponent_ng_template_68_Template(rf, ctx) {
  if (rf & 1) {
    const _r75 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 79);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 80)(4, "cxone-singleselect-dropdown", 81);
    i0.ɵɵtwoWayListener("ngModelChange", function AddEntityComponent_ng_template_68_Template_cxone_singleselect_dropdown_ngModelChange_4_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r75);
      const params_r73 = restoredCtx.params;
      i0.ɵɵtwoWayBindingSet(params_r73.selected, $event) || (params_r73.selected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function AddEntityComponent_ng_template_68_Template_cxone_singleselect_dropdown_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r75);
      const ctx_r76 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r76.onPopoverDropdownValueChanged($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 82)(6, "button", 83);
    i0.ɵɵlistener("click", function AddEntityComponent_ng_template_68_Template_button_click_6_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r75);
      const params_r73 = restoredCtx.params;
      return i0.ɵɵresetView(params_r73.pop.hide());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 84);
    i0.ɵɵlistener("click", function AddEntityComponent_ng_template_68_Template_button_click_9_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r75);
      const params_r73 = restoredCtx.params;
      const ctx_r78 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r78.popoverRemoveFromAdded(params_r73.data, params_r73.pop));
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const params_r73 = ctx.params;
    const ctx_r24 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r24.entity.confirmationMsgForRemoval);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", params_r73.selected);
    i0.ɵɵproperty("options", ctx_r24.entity.parent.options)("label", ctx_r24.entity.parent.label)("search", false)("sortKey", "id");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, "cxone-domain-components.addEntity.popover.no"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 10, "cxone-domain-components.addEntity.popover.yes"));
  }
}
function AddEntityComponent_ng_template_70_Template(rf, ctx) {
  if (rf & 1) {
    const _r81 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div")(1, "span", 79);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 80)(4, "cxone-singleselect-dropdown", 81);
    i0.ɵɵtwoWayListener("ngModelChange", function AddEntityComponent_ng_template_70_Template_cxone_singleselect_dropdown_ngModelChange_4_listener($event) {
      const restoredCtx = i0.ɵɵrestoreView(_r81);
      const params_r79 = restoredCtx.params;
      i0.ɵɵtwoWayBindingSet(params_r79.selected, $event) || (params_r79.selected = $event);
      return i0.ɵɵresetView($event);
    });
    i0.ɵɵlistener("ngModelChange", function AddEntityComponent_ng_template_70_Template_cxone_singleselect_dropdown_ngModelChange_4_listener($event) {
      i0.ɵɵrestoreView(_r81);
      const ctx_r82 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r82.onPopoverDropdownValueChanged($event));
    });
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 82)(6, "button", 83);
    i0.ɵɵlistener("click", function AddEntityComponent_ng_template_70_Template_button_click_6_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r81);
      const params_r79 = restoredCtx.params;
      return i0.ɵɵresetView(params_r79.pop.hide());
    });
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "button", 84);
    i0.ɵɵlistener("click", function AddEntityComponent_ng_template_70_Template_button_click_9_listener() {
      const restoredCtx = i0.ɵɵrestoreView(_r81);
      const params_r79 = restoredCtx.params;
      const ctx_r84 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r84.popoverRemoveAllFromAdded(params_r79.pop));
    });
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "translate");
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const params_r79 = ctx.params;
    const ctx_r26 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r26.entity.confirmationMsgForRemoval);
    i0.ɵɵadvance(2);
    i0.ɵɵtwoWayProperty("ngModel", params_r79.selected);
    i0.ɵɵproperty("options", ctx_r26.entity.parent.options)("label", ctx_r26.entity.parent.label)("search", false)("sortKey", "id");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(8, 8, "cxone-domain-components.addEntity.popover.no"));
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(11, 10, "cxone-domain-components.addEntity.popover.yes"));
  }
}
const _c1 = a0 => ({
  "filtersActive": a0
});
const _c2 = a0 => ({
  count: a0
});
class SelectionHeaderCheckboxComponent {
  constructor() {}
  agInit(params) {
    this.params = params;
  }
  refresh(params) {
    this.params = params;
    return true;
  }
  toggleSelectAll() {
    this.params.context.selectAllCheckBoxesPrevStatus = !this.params.context.selectAllCheckBoxes;
    setTimeout(() => {
      this.params.context.selectOrDeselectAll(this.params);
    }, 200);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SelectionHeaderCheckboxComponent_Factory(t) {
      return new (t || SelectionHeaderCheckboxComponent)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: SelectionHeaderCheckboxComponent,
      selectors: [["selection-header-checkbox"]],
      decls: 1,
      vars: 2,
      consts: [["type", "checkbox", "labelText", "", "checkboxId", "checkbox-grid-header", "name", "checkbox-grid-header", 3, "ngModel", "indeterminate", "clicked", "ngModelChange", "indeterminateChange"]],
      template: function SelectionHeaderCheckboxComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "cxone-checkbox", 0);
          i0.ɵɵlistener("clicked", function SelectionHeaderCheckboxComponent_Template_cxone_checkbox_clicked_0_listener() {
            return ctx.toggleSelectAll();
          });
          i0.ɵɵtwoWayListener("ngModelChange", function SelectionHeaderCheckboxComponent_Template_cxone_checkbox_ngModelChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.params.context.selectAllCheckBoxes, $event) || (ctx.params.context.selectAllCheckBoxes = $event);
            return $event;
          })("indeterminateChange", function SelectionHeaderCheckboxComponent_Template_cxone_checkbox_indeterminateChange_0_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.params.context.rowsPartiallySelected, $event) || (ctx.params.context.rowsPartiallySelected = $event);
            return $event;
          });
          i0.ɵɵelementEnd();
        }
        if (rf & 2) {
          i0.ɵɵtwoWayProperty("ngModel", ctx.params.context.selectAllCheckBoxes)("indeterminate", ctx.params.context.rowsPartiallySelected);
        }
      },
      dependencies: [i1.NgControlStatus, i1.NgModel, i2.CheckboxComponent]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SelectionHeaderCheckboxComponent, [{
    type: Component,
    args: [{
      selector: 'selection-header-checkbox',
      template: "<cxone-checkbox\n  type=\"checkbox\"\n  labelText=\"\"\n  checkboxId=\"checkbox-grid-header\"\n  name=\"checkbox-grid-header\"\n  (clicked)=\"toggleSelectAll()\"\n  [(ngModel)]=\"params.context.selectAllCheckBoxes\"\n  [(indeterminate)]=\"params.context.rowsPartiallySelected\"\n>\n</cxone-checkbox>\n"
    }]
  }], () => [], null);
})();
class AddEntityService {
  constructor(sanitizer) {
    this.sanitizer = sanitizer;
  }
  getIcon(iconString) {
    let svg;
    switch (iconString) {
      // tslint:disable-next-line: max-line-length
      case 'icon-close':
        svg = '<svg width="100%" height="100%" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M18.24 16l7.52-7.52c.64-.64.64-1.6 0-2.24s-1.6-.64-2.24 0L16 13.76 8.48 6.08c-.64-.64-1.6-.64-2.24 0s-.64 1.6 0 2.24L13.76 16l-7.52 7.52c-.64.64-.64 1.6 0 2.24s1.6.64 2.24 0L16 18.24l7.52 7.52c.64.64 1.6.64 2.24 0s.64-1.6 0-2.24L18.24 16z"/></svg>';
        break;
      // tslint:disable-next-line: max-line-length
      case 'icon-search':
        svg = '<svg width="100%" height="100%" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M0 12.8c0 7.04 5.76 12.8 12.8 12.8 2.88 0 5.6-.96 7.84-2.72l8.64 8.64c.64.64 1.6.64 2.24 0s.64-1.6 0-2.24l-8.64-8.64a12.61 12.61 0 002.72-7.84C25.6 5.76 19.84 0 12.8 0S0 5.76 0 12.8zm3.2 0c0-5.28 4.32-9.6 9.6-9.6s9.6 4.32 9.6 9.6-4.32 9.6-9.6 9.6-9.6-4.32-9.6-9.6z"/></svg>';
        break;
      // tslint:disable-next-line: max-line-length
      case 'icon-filter':
        svg = '<svg width="100%" height="100%" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M26.88 3.2l-9.28 11.68v11.040l-3.2 1.76v-12.8l-0.64-0.8-8.64-10.88h21.76zM30.72 0h-29.44c-0.48 0-0.96 0.32-1.12 0.8-0.32 0.48-0.16 1.12 0.16 1.44l10.88 13.76v14.4c0 0.48 0.48 1.12 0.96 1.44 0.16 0.16 0.48 0.16 0.64 0.16s0.32 0 0.64-0.16l6.4-3.36c0.48-0.16 1.12-0.64 1.12-1.28v-11.2l10.88-13.76c0.32-0.48 0.32-0.96 0.16-1.44-0.32-0.48-0.8-0.8-1.28-0.8v0z"/></svg>';
        break;
      default:
        svg = undefined;
        break;
    }
    if (svg === undefined) {
      return;
    }
    return this.sanitizer.bypassSecurityTrustHtml(svg);
  }
  /** @nocollapse */
  static {
    this.ɵfac = function AddEntityService_Factory(t) {
      return new (t || AddEntityService)(i0.ɵɵinject(i1$1.DomSanitizer));
    };
  }
  /** @nocollapse */
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: AddEntityService,
      factory: AddEntityService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEntityService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1$1.DomSanitizer
  }], null);
})();
class SearchFilterPipe {
  transform(items, query, field) {
    if (query === null || query && query.length === 0) {
      return items;
    }
    return items.filter(item => {
      if (typeof item === 'string' && field === undefined) {
        return item.toLowerCase().includes(query.toLowerCase());
      } else {
        return item[field].toLowerCase().includes(query.toLowerCase());
      }
    });
  }
  /** @nocollapse */
  static {
    this.ɵfac = function SearchFilterPipe_Factory(t) {
      return new (t || SearchFilterPipe)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
      name: "searchFilter",
      type: SearchFilterPipe,
      pure: false
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchFilterPipe, [{
    type: Pipe,
    args: [{
      name: 'searchFilter',
      pure: false
    }]
  }], null, null);
})();
class AddEntityComponent {
  constructor(addEntityService, translationPipe) {
    this.addEntityService = addEntityService;
    this.translationPipe = translationPipe;
    this.showFilters = false;
    this.totalAddedEntities = 0;
    this.fetchPageMutex = new Mutex();
    this.filterFeature = true;
    this.multiSelRows = [];
    this.multiSelNodes = [];
    this.selectAllCheckBoxesPrevStatus = false;
    this.addCheckbox = {
      headerName: '',
      checkboxSelection: true,
      width: 50,
      minWidth: 50,
      resizable: false,
      suppressSizeToFit: true,
      sortable: false,
      headerClass: 'checkBoxClass',
      headerCheckboxSelectionFilteredOnly: true,
      headerComponent: SelectionHeaderCheckboxComponent
    };
    this.onGridFilterChanged = params => {
      this.dataSize = params.api.getDisplayedRowCount();
    };
    this.onGridReady = params => {
      this.gridApi = params.api;
      this.initializeFilterOptionsChosen();
      if (!this.entity.disableInfiniteScroll) {
        this.gridApi.setGridOption('datasource', this.entity.fetchData);
      } else {
        this.gridApi.setGridOption('rowData', this.dataSet);
        this.dataSize = this.dataSet.length;
      }
    };
    this.onRowSelectionChanged = params => {
      if (this.multiSelectCheckbox) {
        const api = params.api;
        this.multiSelRows = api.getSelectedRows();
        this.multiSelNodes = api.getSelectedNodes();
        this.partialSelection();
      } else {
        const api = params.api;
        const selectedRow = api.getSelectedRows()[0];
        if (selectedRow !== undefined) {
          const selectedNodes = api.getSelectedNodes();
          if (selectedNodes !== undefined) {
            if (this.selectedEntities.indexOf(selectedRow) < 0) {
              this.selectedEntities.push(selectedRow);
            }
            selectedNodes[0].setSelected(false);
            if (!this.entity.disableInfiniteScroll) {
              this.gridApi.refreshInfiniteCache();
            } else {
              this.dataSet = this.dataSet.filter(item => item[this.entity.primaryColumnKey] !== selectedRow[this.entity.primaryColumnKey]);
              this.applyFilter();
            }
          }
        }
      }
    };
    this.filterOptionsChosen = {};
    this.selectedTags = [];
    this.filterOperation = '';
    this.searchTxt = this.translationPipe.transform('cxone-domain-components.addEntity.searched');
    this.filterTxt = this.translationPipe.transform('cxone-domain-components.addEntity.filtered');
    this.addedEntitiesData = new BehaviorSubject([]);
    this.addedEntitiesSearchInput = new Subject();
    this.addedEntitiesSearchInput.pipe(debounceTime(500), distinctUntilChanged()).subscribe(value => {
      this.searchAddedEntities(value);
    });
    // boolean flags
    this.removeAllSelectedInProgress = false;
    this.removeAllAddedInProgress = false;
  }
  defineGrid() {
    this.gridOptions = {
      rowHeight: 36,
      rowSelection: 'single',
      rowBuffer: 0,
      onSelectionChanged: this.onRowSelectionChanged,
      onGridReady: this.onGridReady,
      onFilterChanged: this.onGridFilterChanged,
      pagination: false,
      suppressRowClickSelection: false,
      context: this
    };
    if (this.multiSelectCheckbox) {
      const primaryColKey = this.entity.primaryColumnKey;
      this.gridOptions.rowSelection = 'multiple';
      this.gridOptions.getRowId = function (item) {
        return item.data[primaryColKey].toString();
      };
      this.gridOptions.onBodyScroll = params => {
        const gridApi = params.api;
        if (this.selectAllCheckBoxes && !this.rowsPartiallySelected) {
          gridApi.forEachNode(node => {
            node.setSelected(true);
          });
        }
      };
      delete this.gridOptions.suppressRowClickSelection;
    }
    if (!this.entity.disableInfiniteScroll) {
      this.gridOptions.rowModelType = 'infinite';
      this.gridOptions.cacheBlockSize = 50;
      this.gridOptions.infiniteInitialRowCount = 50;
      this.gridOptions.maxConcurrentDatasourceRequests = 1;
      this.gridOptions.paginationAutoPageSize = true;
    }
  }
  initializeFilterOptionsChosen() {
    this.entity.filters.forEach(filter => this.filterOptionsChosen[filter.id] = []);
  }
  filterCollection(items, filters) {
    return items.filter(item => {
      let flag = true;
      Object.keys(filters).forEach(key => {
        const value = filters[key];
        if ((value !== '' || value !== undefined && item[key] !== undefined) && !item[key].toLowerCase().includes(value.toLowerCase())) {
          flag = false;
        }
      });
      return flag;
    });
  }
  applyFilter() {
    const searchField = {};
    searchField[this.entity.searchFieldKey] = this.searchQuery || '';
    let filteredData = this.filterCollection(this.dataSet, searchField);
    if (this.entity.onFiltersChanged) {
      filteredData = this.entity.onFiltersChanged(filteredData, this.filterOptionsChosen);
    }
    if (this.entity.disableInfiniteScroll) {
      this.gridApi.setRowData(filteredData);
    } else {
      this.gridApi.refreshInfiniteCache();
    }
    this.gridApi.onFilterChanged();
  }
  partialSelection() {
    const loadedRowCount = this.gridApi.getInfiniteRowCount() === this.dataSize ? this.dataSize : this.gridApi.getInfiniteRowCount() - 1;
    let allSelected = this.multiSelRows.length === loadedRowCount;
    if (this.searchQuery && this.searchQuery.length > 0) {
      allSelected = false;
    }
    if (this.multiSelRows.length === 0 || allSelected) {
      this.rowsPartiallySelected = false;
      this.selectAllCheckBoxes = allSelected;
      return;
    }
    this.rowsPartiallySelected = true;
    this.selectAllCheckBoxes = false;
  }
  ngOnInit() {
    this.selectedEntities = [];
    this.addedEntities = [...this.entity.assignedEntities];
    this.removedEntities = [];
    this.entity.addedEntitiesQuery = '';
    this.multiSelectCheckbox = this.entity.enableBulkOperations;
    this.filterFeature = this.entity.filters.length > 0 ? true : false;
    if (this.multiSelectCheckbox && !this.entity.columnDefs.includes(this.addCheckbox)) {
      this.entity.columnDefs.unshift(this.addCheckbox);
    }
    this.dataSet = this.entity.dataset;
    this.defineGrid();
    if (this.entity.useInfiniteScrollForAddedEntities) {
      this.fetchData(0);
    } else {
      const filteredData = this.transform(this.addedEntities, this.entity.addedEntitiesQuery, this.entity.searchFieldKey);
      this.totalAddedEntities = filteredData.length;
      const fetchedData = [...filteredData];
      this.addedEntitiesData.next(fetchedData);
    }
  }
  ngAfterViewInit() {
    this.scrollers.changes.subscribe(item => {
      if (this.scrollers.toArray().length > 0 && !this.scroller) {
        this.scroller = this.scrollers.first;
      }
    });
  }
  clearSearchField() {
    this.onSearchQueryChange('');
  }
  selectAll() {
    //this.allRowsSelected = true;
    if (!this.entity.disableInfiniteScroll) {
      this.selectAllWithInfiniteScrollSupport();
    } else {
      this.selectAllWithoutInfiniteScrollSupport();
    }
  }
  selectAllWithInfiniteScrollSupport() {
    this.gridApi.getRenderedNodes().forEach(renderedNode => {
      if (!renderedNode.data) return;
      if (this.selectedEntities.indexOf(renderedNode.data) < 0) {
        this.selectedEntities.push(renderedNode.data);
      }
    });
    this.gridApi.onFilterChanged();
    this.gridApi.refreshInfiniteCache();
  }
  selectAllWithoutInfiniteScrollSupport() {
    this.gridApi.forEachNode(rowData => {
      if (this.selectedEntities.indexOf(rowData.data) < 0) {
        this.selectedEntities.push(rowData.data);
        this.dataSet = this.dataSet.filter(item => item[this.entity.primaryColumnKey] !== rowData.data[this.entity.primaryColumnKey]);
      }
    });
    this.applyFilter();
  }
  submit() {
    const output = this.selectedEntities.concat(this.addedEntities);
    this.removedEntities.forEach(removedEntity => {
      const indexSelected = this.selectedEntities.findIndex(item => item[this.entity.primaryColumnKey] === removedEntity[this.entity.primaryColumnKey]);
      if (indexSelected >= 0) {
        this.selectedEntities.splice(indexSelected, 1);
      } else {
        const indexNew = this.entity.newEntities.findIndex(item => item[this.entity.primaryColumnKey] === removedEntity[this.entity.primaryColumnKey]);
        if (indexNew >= 0) {
          this.entity.newEntities.splice(indexNew, 1);
        } else {
          this.entity.removedEntities.push(removedEntity);
        }
      }
    });
    const newEntities = [];
    this.selectedEntities.forEach(selectedEntity => {
      const indexRemoved = this.entity.removedEntities.findIndex(item => item[this.entity.primaryColumnKey] === selectedEntity[this.entity.primaryColumnKey]);
      if (indexRemoved >= 0) {
        this.entity.removedEntities.splice(indexRemoved, 1);
      } else {
        newEntities.push(selectedEntity);
      }
    });
    this.entity.newEntities = this.entity.newEntities.concat(newEntities);
    return output;
  }
  onSearchQueryChange(query) {
    this.searchQuery = query;
    if (!this.entity.disableInfiniteScroll) {
      const data = this.filterEntitiesForSearchQuery(this.entity.dataset, query);
      if (JSON.stringify(this.dataSet) !== JSON.stringify(data)) {
        this.dataSet = data;
        this.gridApi.onFilterChanged();
      }
      this.entity.onSearchQueryChanged(query);
      this.gridApi.refreshInfiniteCache();
    }
    this.applyFilter();
    if (this.searchQuery && this.searchQuery.length > 0) {
      this.filterOperation = this.searchTxt;
    } else if (this.selectedTags.length > 0) {
      this.filterOperation = this.filterTxt;
    } else {
      this.filterOperation = '';
    }
    if (this.selectAllCheckBoxes) {
      this.rowsPartiallySelected = true;
      this.selectAllCheckBoxes = false;
    }
  }
  onFiltersSelectionChange() {
    const tags = [];
    Object.keys(this.filterOptionsChosen).forEach(key => {
      if (this.filterOptionsChosen[key]) {
        this.filterOptionsChosen[key].forEach(filterOption => {
          tags.push({
            filterKey: key,
            id: filterOption.id,
            text: filterOption.name
          });
        });
      }
    });
    this.selectedTags = tags;
    if (!this.entity.disableInfiniteScroll) {
      this.gridApi.onFilterChanged();
      this.gridApi.refreshInfiniteCache();
    } else {
      this.applyFilter();
    }
    if (this.selectedTags.length > 0) {
      this.filterOperation = this.filterTxt;
    } else if (this.searchQuery !== undefined && this.searchQuery !== '') {
      this.filterOperation = this.searchTxt;
    } else {
      this.filterOperation = '';
    }
  }
  onTagDeleted(tag) {
    const index = this.filterOptionsChosen[tag.filterKey].findIndex(x => x.id === tag.id);
    this.filterOptionsChosen[tag.filterKey].splice(index, 1);
    this.onFiltersSelectionChange();
  }
  removeAllSelected() {
    if (this.entity.enableBulkOperations) {
      this.toggleRemoveAllSelectedInProgress();
      this.dataSet.push(...this.selectedEntities);
      this.selectedEntities = [];
      this.applyFilter();
      setTimeout(() => {
        this.toggleRemoveAllSelectedInProgress();
      }, 500);
    } else if (!this.entity.disableInfiniteScroll) {
      this.selectedEntities = [];
      this.gridApi.onFilterChanged();
      this.gridApi.refreshInfiniteCache();
    } else {
      this.dataSet.push(...this.selectedEntities);
      this.selectedEntities = [];
      this.applyFilter();
    }
  }
  removeAllAdded() {
    if (this.entity.enableBulkOperations) {
      this.toggleRemoveAllAddedInProgress();
      this.removeAllAddedWithBulkOperationEnabled();
      setTimeout(() => {
        this.toggleRemoveAllAddedInProgress();
      }, 500);
    } else if (!this.entity.disableInfiniteScroll) {
      this.removeAllAddedWithInfiniteScrollSupport();
    } else {
      this.removeAllAddedWithoutInfiniteScrollSupport();
    }
  }
  removeAllAddedWithInfiniteScrollSupport() {
    if (this.entity.useInfiniteScrollForAddedEntities) {
      //const range = this.scroller.getRenderedRange();
      //const removeCount = range.end-range.start;
      //const removed = this.addedEntitiesData.value.splice(range.start, removeCount);
      const removed = this.addedEntitiesData.value;
      removed.forEach(removedNode => {
        const index = this.addedEntities.findIndex(item => item[this.entity.primaryColumnKey] === removedNode[this.entity.primaryColumnKey]);
        this.addedEntities.splice(index, 1);
      });
      this.removedEntities = this.removedEntities.concat(removed);
      this.refreshAddedEntitiesView(this.scroller.getRenderedRange().start);
    } else {
      this.addedEntities = [];
      this.addedEntitiesData.next([...this.addedEntities]);
      this.totalAddedEntities = 0;
    }
    this.gridApi.onFilterChanged();
    this.gridApi.refreshInfiniteCache();
  }
  removeAllAddedWithoutInfiniteScrollSupport() {
    this.dataSet.push(...this.addedEntities);
    this.addedEntities = [];
    this.addedEntitiesData.next([...this.addedEntities]);
    this.totalAddedEntities = 0;
    this.applyFilter();
  }
  removeSelectedEntity(selectedEntity) {
    const index = this.selectedEntities.findIndex(item => item[this.entity.primaryColumnKey] === selectedEntity[this.entity.primaryColumnKey]);
    this.selectedEntities.splice(index, 1);
    if (!this.entity.disableInfiniteScroll) {
      this.gridApi.refreshInfiniteCache();
    } else {
      this.dataSet.push(selectedEntity);
      this.applyFilter();
    }
  }
  removeAddedEntity(addedEntity) {
    const index = this.addedEntities.findIndex(item => item[this.entity.primaryColumnKey] === addedEntity[this.entity.primaryColumnKey]);
    this.addedEntities.splice(index, 1);
    this.removedEntities.push(addedEntity);
    if (!this.entity.disableInfiniteScroll) {
      this.gridApi.refreshInfiniteCache();
    } else {
      this.dataSet.push(addedEntity);
      this.applyFilter();
    }
    const index2 = this.addedEntitiesData.value.findIndex(item => item[this.entity.primaryColumnKey] === addedEntity[this.entity.primaryColumnKey]);
    if (this.entity.useInfiniteScrollForAddedEntities) {
      this.refreshAddedEntitiesView(index2);
    } else {
      this.addedEntitiesData.value.splice(index2, 1);
      this.addedEntitiesData.next([...this.addedEntitiesData.value]);
      this.totalAddedEntities = this.totalAddedEntities - 1;
    }
  }
  popoverRemoveFromAdded(entity, popoverRef) {
    if (this.entity.parent && this.entity.parent.selected && this.entity.parent.selected[this.entity.parent.label]) {
      entity[this.entity.parentEntityKeyIdentifier] = this.entity.parent.selected[this.entity.parent.label];
      this.removeAddedEntity(entity);
      popoverRef.hide();
    }
  }
  popoverRemoveAllFromAdded(popoverRef) {
    if (this.entity.enableBulkOperations) {
      if (this.entity.parent && this.entity.parent.selected && this.entity.parent.selected[this.entity.parent.label]) {
        popoverRef.hide();
        this.toggleRemoveAllAddedInProgress();
        this.removeAllAddedWithBulkOperationEnabled();
        this.totalAddedEntities = 0;
        this.applyFilter();
        this.toggleRemoveAllAddedInProgress();
      }
    } else {
      popoverRef.hide();
      this.removeAllAdded();
    }
  }
  async removeAllAddedWithBulkOperationEnabled() {
    while (this.addedEntitiesData.value.length > 0) {
      if (this.entity.parent && this.entity.parent.label) {
        this.addedEntitiesData.value.forEach(entity => {
          entity[this.entity.parentEntityKeyIdentifier] = this.entity.parent.selected[this.entity.parent.label];
        });
      }
      this.dataSet.push(...this.addedEntitiesData.value);
      this.removedEntities.push(...this.addedEntitiesData.value);
      this.addedEntitiesData.next([]);
      await this.fetchData(0);
    }
  }
  getPopoverContext(entityRow, popoverRef) {
    return {
      params: {
        data: entityRow,
        pop: popoverRef,
        selected: this.entity.parent.options.find(x => x[this.entity.parent.label] === entityRow[this.entity.parentEntityKeyIdentifier])
      }
    };
  }
  getRemoveAllPopoverContext(popoverRef) {
    return {
      params: {
        pop: popoverRef,
        selected: undefined
      }
    };
  }
  onPopoverDropdownValueChanged(selected) {
    this.entity.parent.selected = selected;
  }
  clearAll() {
    this.initializeFilterOptionsChosen();
    this.onFiltersSelectionChange();
  }
  toggleFilters() {
    this.showFilters = !this.showFilters;
    const className = this.showFilters ? 'add-entity-grid-wrapper' : 'add-entity-grid-with-filters-wrapper';
    const newClassName = !this.showFilters ? 'add-entity-grid-wrapper' : 'add-entity-grid-with-filters-wrapper';
    document.getElementsByClassName(className)[0].setAttribute('class', newClassName);
  }
  filterEntitiesForSearchQuery(data, searchQuery) {
    if (searchQuery === '' || searchQuery === undefined) {
      return data;
    }
    data = data.filter(x => {
      return x[this.entity.searchFieldKey].toLowerCase().includes(searchQuery.toLowerCase()) ? true : false;
    });
    return data;
  }
  fetchData(index) {
    return new Promise((resolve, reject) => {
      const params = this.getFetchAddedEntitiesParams(index);
      this.entity.fetchAddedEntities(params).then(result => {
        this.totalAddedEntities = result.totalRecords;
        let fetchedData = [...this.addedEntitiesData.value];
        fetchedData = fetchedData.concat(result.data);
        this.addedEntitiesData.next(fetchedData);
        resolve();
      }).catch(error => {
        console.error('cannot fetch added users');
        reject();
      });
    });
  }
  async onScroll(index) {
    if (this.entity.useInfiniteScrollForAddedEntities) {
      if (typeof this.addedEntitiesMaxScrollIndex === 'undefined') {
        this.addedEntitiesMaxScrollIndex = index;
      }
      const fetchPageRelease = await this.fetchPageMutex.acquire();
      try {
        if (this.addedEntitiesMaxScrollIndex < index) {
          if (index > this.addedEntitiesData.value.length - 10 && this.addedEntitiesData.value.length !== this.totalAddedEntities) {
            await this.fetchData(index);
          }
          this.addedEntitiesMaxScrollIndex = index;
        }
      } finally {
        fetchPageRelease();
      }
    }
  }
  async refreshAddedEntitiesView(currentIndex) {
    this.addedEntitiesMaxScrollIndex = 0;
    this.addedEntitiesData = new BehaviorSubject([]);
    if (this.entity.useInfiniteScrollForAddedEntities) {
      await this.fetchData(0);
      this.scroller.checkViewportSize();
      this.scroller.scrollToIndex(0);
    } else {
      const filteredData = this.transform(this.addedEntities, this.entity.addedEntitiesQuery, this.entity.searchFieldKey);
      this.totalAddedEntities = filteredData.length;
      const fetchedData = [...filteredData];
      this.addedEntitiesData.next(fetchedData);
    }
  }
  onAddedSearchQueryChange(event) {
    this.addedEntitiesSearchInput.next(event);
  }
  searchAddedEntities(query) {
    this.searchQueryAdded = query;
    this.entity.addedEntitiesQuery = this.searchQueryAdded;
    this.refreshAddedEntitiesView(0);
  }
  clearAddedSearchQuery() {
    this.searchAddedEntities('');
  }
  getFetchAddedEntitiesParams(index) {
    return {
      index: index,
      newEntities: this.entity.newEntities,
      excludedEntities: this.entity.removedEntities.concat(this.removedEntities)
    };
  }
  transform(items, query, field) {
    if (query === null || query && query.length === 0) {
      return items;
    }
    return items.filter(item => {
      if (typeof item === 'string' && field === undefined) {
        return item.toLowerCase().includes(query.toLowerCase());
      } else {
        return item[field].toLowerCase().includes(query.toLowerCase());
      }
    });
  }
  toggleRemoveAllSelectedInProgress() {
    this.removeAllSelectedInProgress = !this.removeAllSelectedInProgress;
  }
  toggleRemoveAllAddedInProgress() {
    this.removeAllAddedInProgress = !this.removeAllAddedInProgress;
  }
  selectOrDeselectAll(params) {
    this.selectAllCheckBoxesPrevStatus = params.context.selectAllCheckBoxesPrevStatus;
    const api = params.api;
    if (this.selectAllCheckBoxesPrevStatus) {
      this.gridApi.forEachNode(node => {
        node.setSelected(true);
      });
      this.multiSelRows = api.getSelectedRows();
    } else {
      this.gridApi.forEachNode(node => {
        node.setSelected(false);
      });
      this.multiSelRows = api.getSelectedRows();
    }
  }
  moveSelected() {
    this.selectedEntities = [...this.selectedEntities, ...this.multiSelRows];
    const nodesLength = this.multiSelNodes.length;
    for (let i = 0; i < nodesLength; i++) {
      this.multiSelNodes[i].setSelected(false);
    }
    this.gridApi.purgeInfiniteCache();
  }
  ngOnDestroy() {
    if (this.multiSelectCheckbox) {
      this.entity.columnDefs.shift();
    }
  }
  /** @nocollapse */
  static {
    this.ɵfac = function AddEntityComponent_Factory(t) {
      return new (t || AddEntityComponent)(i0.ɵɵdirectiveInject(AddEntityService), i0.ɵɵdirectiveInject(i2$1.TranslationPipe));
    };
  }
  /** @nocollapse */
  static {
    this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: AddEntityComponent,
      selectors: [["cxone-add-entity"]],
      viewQuery: function AddEntityComponent_Query(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵviewQuery(CdkVirtualScrollViewport, 5);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.scrollers = _t);
        }
      },
      inputs: {
        entity: "entity"
      },
      decls: 72,
      vars: 68,
      consts: [[1, "cxone-add-entity"], [1, "content-wrapper"], [1, "left-section"], [3, "customOmnibar", "showFooter", "ngClass"], [1, "custom-omnibar-wrapper", "flex-container"], ["class", "icon-wrapper", 4, "ngIf"], [1, "count-wrapper", "flex-container"], [1, "count"], [4, "ngIf"], [1, "vertical-line"], ["class", "select-all-link", 4, "ngIf"], [1, "search-wrapper", "flex-container"], [1, "ng-valid", "ng-dirty", "ng-touched", 3, "ngModel", "placeholder", "ngModelChange"], [1, "button-wrapper"], ["class", "icon clear-btn", 3, "innerHTML", "hidden", "click", 4, "ngIf"], ["class", "icon search-btn", 3, "innerHTML", "click", 4, "ngIf"], ["class", "filter-wrapper", 4, "ngIf"], ["class", "selected-filter-tags-wrapper", 4, "ngIf"], ["class", "movePush", 4, "ngIf"], [1, "filters-wrapper"], ["class", "dropdown-wrapper", 4, "ngFor", "ngForOf"], [1, "action-btns"], [3, "click"], [1, "add-entity-grid-wrapper"], [3, "columnDefs", "gridOptions"], [1, "right-section"], [3, "title"], [1, "top-row"], [1, "search-wrapper"], [1, "search-selected", 3, "placeholder"], ["searchQuerySelected", ""], ["class", "icon clear-btn", 3, "innerHTML", "click", 4, "ngIf"], ["class", "icon search-btn", 3, "innerHTML", 4, "ngIf"], ["cxoneOverflowTooltip", "", 3, "ngClass", "click"], ["class", "bottom-row", 4, "ngIf"], ["class", "no-rows", 4, "ngIf"], ["class", "remove-all-spinner", 4, "ngIf"], [1, "search-added", 3, "ngModel", "placeholder", "ngModelChange"], ["addedSearchQuery", ""], ["cxoneOverflowTooltip", "", "containerClass", "removal-popover", "placement", "left", 3, "ngClass", "popover", "adaptivePosition", "outsideClick", "popoverContext", 4, "ngIf"], ["cxoneOverflowTooltip", "", 3, "ngClass", "click", 4, "ngIf"], ["itemSize", "49", "minBufferPx", "800", "maxBufferPx", "800", "class", "bottom-row", 3, "scrolledIndexChange", 4, "ngIf"], ["removeAddedEntityPopover", ""], ["removeAllAddedEntityPopover", ""], [1, "icon-wrapper"], [1, "icon-btn", 3, "innerHTML"], [1, "select-all-link"], [1, "icon", "clear-btn", 3, "innerHTML", "hidden", "click"], [1, "icon", "search-btn", 3, "innerHTML", "click"], [1, "filter-wrapper"], [1, "icon", "filter-btn", 3, "innerHTML", "click"], [1, "selected-filter-tags-wrapper"], [3, "tagsSource", "removable", "tagDeleted"], [1, "movePush"], [1, "cxone-btn", "btn-medium", "active-btn", "btn-secondary", "btn-bg-is-white", 3, "disabled", "click"], [1, "dropdown-wrapper"], [1, "filter-label", 3, "innerText"], [3, "ngModel", "options", "search", "bulkOperations", "placeholder", "sortKey", "sortOrder", "maxSelectionLimit", "maxItemsToDisplay", "enableInfiniteScroll", "serverSideSearch", "ngModelChange", "onServerSideSearch", "onLoadData"], [1, "icon", "clear-btn", 3, "innerHTML", "click"], [1, "icon", "search-btn", 3, "innerHTML"], [1, "bottom-row"], ["class", "selected-row", 4, "ngFor", "ngForOf"], [1, "selected-row"], [1, "entity-info"], [1, "title-text", 3, "innerText"], ["class", "subtitle-text", 3, "innerText", 4, "ngIf"], [1, "remove-icon", 3, "click"], [3, "innerHTML"], [1, "subtitle-text", 3, "innerText"], [1, "no-rows"], [3, "innerText"], [1, "remove-all-spinner"], [3, "isSpinner"], ["cxoneOverflowTooltip", "", "containerClass", "removal-popover", "placement", "left", 3, "ngClass", "popover", "adaptivePosition", "outsideClick", "popoverContext"], ["pop", "bs-popover"], ["itemSize", "49", "minBufferPx", "800", "maxBufferPx", "800", 1, "bottom-row", 3, "scrolledIndexChange"], ["class", "remove-icon", 3, "click", 4, "ngIf"], ["class", "remove-icon", "placement", "bottom", "containerClass", "removal-popover", 3, "popover", "outsideClick", "popoverContext", "adaptivePosition", 4, "ngIf"], ["placement", "bottom", "containerClass", "removal-popover", 1, "remove-icon", 3, "popover", "outsideClick", "popoverContext", "adaptivePosition"], [1, "removal-msg"], [1, "dropdown"], ["id", "parent_entity", 3, "ngModel", "options", "label", "search", "sortKey", "ngModelChange"], [1, "confirmBtns"], ["id", "popup-cancel", 1, "cxone-btn", "btn-secondary", "btn-sm", 3, "click"], ["id", "popup-save", 1, "cxone-btn", "btn-default", "btn-primary", "btn-sm", 3, "click"]],
      template: function AddEntityComponent_Template(rf, ctx) {
        if (rf & 1) {
          i0.ɵɵelementStart(0, "div", 0)(1, "div", 1)(2, "div", 2)(3, "cxone-omnibar", 3)(4, "cxone-omnibar-custom-content")(5, "div", 4);
          i0.ɵɵtemplate(6, AddEntityComponent_div_6_Template, 2, 1, "div", 5);
          i0.ɵɵelementStart(7, "div", 6)(8, "div", 7);
          i0.ɵɵtext(9);
          i0.ɵɵpipe(10, "translate");
          i0.ɵɵtemplate(11, AddEntityComponent_span_11_Template, 3, 4, "span", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelement(12, "div", 9);
          i0.ɵɵtemplate(13, AddEntityComponent_div_13_Template, 5, 4, "div", 10)(14, AddEntityComponent_div_14_Template, 3, 4, "div", 8);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(15, "div", 11)(16, "cxone-text-input", 12);
          i0.ɵɵtwoWayListener("ngModelChange", function AddEntityComponent_Template_cxone_text_input_ngModelChange_16_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.searchQuery, $event) || (ctx.searchQuery = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function AddEntityComponent_Template_cxone_text_input_ngModelChange_16_listener() {
            return ctx.onSearchQueryChange(ctx.searchQuery);
          });
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(17, "div", 13);
          i0.ɵɵtemplate(18, AddEntityComponent_div_18_Template, 1, 2, "div", 14)(19, AddEntityComponent_div_19_Template, 1, 1, "div", 15);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(20, AddEntityComponent_div_20_Template, 2, 1, "div", 16)(21, AddEntityComponent_div_21_Template, 2, 2, "div", 17)(22, AddEntityComponent_div_22_Template, 4, 4, "div", 18);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(23, "cxone-omnibar-filters")(24, "div", 19);
          i0.ɵɵtemplate(25, AddEntityComponent_div_25_Template, 3, 12, "div", 20);
          i0.ɵɵelementStart(26, "div", 21)(27, "a", 22);
          i0.ɵɵlistener("click", function AddEntityComponent_Template_a_click_27_listener() {
            return ctx.clearAll();
          });
          i0.ɵɵtext(28);
          i0.ɵɵpipe(29, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(30, "a", 22);
          i0.ɵɵlistener("click", function AddEntityComponent_Template_a_click_30_listener() {
            return ctx.toggleFilters();
          });
          i0.ɵɵtext(31);
          i0.ɵɵpipe(32, "translate");
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵelementStart(33, "div", 23);
          i0.ɵɵelement(34, "cxone-grid", 24);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(35, "div", 25)(36, "cxone-tabs")(37, "cxone-tab", 26);
          i0.ɵɵpipe(38, "translate");
          i0.ɵɵelementStart(39, "div", 27)(40, "div", 28);
          i0.ɵɵelement(41, "cxone-text-input", 29, 30);
          i0.ɵɵpipe(43, "translate");
          i0.ɵɵelementStart(44, "div", 13);
          i0.ɵɵtemplate(45, AddEntityComponent_div_45_Template, 1, 1, "div", 31)(46, AddEntityComponent_div_46_Template, 1, 1, "div", 32);
          i0.ɵɵelementEnd()();
          i0.ɵɵelementStart(47, "a", 33);
          i0.ɵɵlistener("click", function AddEntityComponent_Template_a_click_47_listener() {
            return ctx.removeAllSelected();
          });
          i0.ɵɵtext(48);
          i0.ɵɵpipe(49, "translate");
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(50, AddEntityComponent_ul_50_Template, 3, 5, "ul", 34)(51, AddEntityComponent_div_51_Template, 2, 1, "div", 35)(52, AddEntityComponent_div_52_Template, 2, 1, "div", 36);
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(53, "cxone-tab", 26);
          i0.ɵɵpipe(54, "translate");
          i0.ɵɵelementStart(55, "div", 27)(56, "div", 28)(57, "cxone-text-input", 37, 38);
          i0.ɵɵtwoWayListener("ngModelChange", function AddEntityComponent_Template_cxone_text_input_ngModelChange_57_listener($event) {
            i0.ɵɵtwoWayBindingSet(ctx.searchQueryAdded, $event) || (ctx.searchQueryAdded = $event);
            return $event;
          });
          i0.ɵɵlistener("ngModelChange", function AddEntityComponent_Template_cxone_text_input_ngModelChange_57_listener() {
            return ctx.onAddedSearchQueryChange(ctx.searchQueryAdded);
          });
          i0.ɵɵpipe(59, "translate");
          i0.ɵɵelementEnd();
          i0.ɵɵelementStart(60, "div", 13);
          i0.ɵɵtemplate(61, AddEntityComponent_div_61_Template, 1, 1, "div", 31)(62, AddEntityComponent_div_62_Template, 1, 1, "div", 32);
          i0.ɵɵelementEnd()();
          i0.ɵɵtemplate(63, AddEntityComponent_a_63_Template, 4, 10, "a", 39)(64, AddEntityComponent_a_64_Template, 3, 6, "a", 40);
          i0.ɵɵelementEnd();
          i0.ɵɵtemplate(65, AddEntityComponent_cdk_virtual_scroll_viewport_65_Template, 3, 3, "cdk-virtual-scroll-viewport", 41)(66, AddEntityComponent_div_66_Template, 2, 1, "div", 35)(67, AddEntityComponent_div_67_Template, 2, 1, "div", 36);
          i0.ɵɵelementEnd()()()()();
          i0.ɵɵtemplate(68, AddEntityComponent_ng_template_68_Template, 12, 12, "ng-template", null, 42, i0.ɵɵtemplateRefExtractor)(70, AddEntityComponent_ng_template_70_Template, 12, 12, "ng-template", null, 43, i0.ɵɵtemplateRefExtractor);
        }
        if (rf & 2) {
          const _r10 = i0.ɵɵreference(42);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("customOmnibar", true)("showFooter", ctx.showFilters)("ngClass", i0.ɵɵpureFunction1(58, _c1, (ctx.selectedTags == null ? null : ctx.selectedTags.length) !== 0));
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngIf", ctx.entity.icon);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(10, 39, "cxone-domain-components.addEntity.total", i0.ɵɵpureFunction1(60, _c2, ctx.dataSize)), " ");
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", (ctx.filterOperation == null ? null : ctx.filterOperation.length) > 0);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.multiSelectCheckbox);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.multiSelectCheckbox);
          i0.ɵɵadvance(2);
          i0.ɵɵtwoWayProperty("ngModel", ctx.searchQuery);
          i0.ɵɵproperty("placeholder", ctx.entity.omnibar.searchPlaceholderText);
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", ctx.searchQuery && (ctx.searchQuery == null ? null : ctx.searchQuery.length) > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.searchQuery === undefined || (ctx.searchQuery == null ? null : ctx.searchQuery.length) === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterFeature);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.filterFeature);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.multiSelectCheckbox);
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("ngForOf", ctx.entity.filters);
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(29, 42, "cxone-domain-components.addEntity.clearAll"));
          i0.ɵɵadvance(3);
          i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(32, 44, "cxone-domain-components.addEntity.close"), " ");
          i0.ɵɵadvance(3);
          i0.ɵɵproperty("columnDefs", ctx.entity.columnDefs)("gridOptions", ctx.gridOptions);
          i0.ɵɵadvance(3);
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(38, 46, "cxone-domain-components.addEntity.selectedCount", i0.ɵɵpureFunction1(62, _c2, ctx.selectedEntities == null ? null : ctx.selectedEntities.length)));
          i0.ɵɵadvance(4);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(43, 49, "cxone-domain-components.addEntity.placeholder.selected"));
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", _r10 && (_r10.modelValue == null ? null : _r10.modelValue.length) > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", _r10 && (_r10.modelValue == null ? null : _r10.modelValue.length) === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(64, _c0, (ctx.selectedEntities == null ? null : ctx.selectedEntities.length) === 0));
          i0.ɵɵadvance();
          i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(49, 51, "cxone-domain-components.addEntity.removeAll"));
          i0.ɵɵadvance(2);
          i0.ɵɵproperty("ngIf", !ctx.removeAllSelectedInProgress);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.selectedEntities == null ? null : ctx.selectedEntities.length) === 0 && !ctx.removeAllSelectedInProgress);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.removeAllSelectedInProgress);
          i0.ɵɵadvance();
          i0.ɵɵpropertyInterpolate("title", i0.ɵɵpipeBind2(54, 53, "cxone-domain-components.addEntity.addedCount", i0.ɵɵpureFunction1(66, _c2, ctx.totalAddedEntities)));
          i0.ɵɵadvance(4);
          i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(59, 56, "cxone-domain-components.addEntity.placeholder.added"));
          i0.ɵɵtwoWayProperty("ngModel", ctx.searchQueryAdded);
          i0.ɵɵadvance(4);
          i0.ɵɵproperty("ngIf", ctx.searchQueryAdded && ctx.searchQueryAdded.length > 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.searchQueryAdded || ctx.searchQueryAdded.length === 0);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.entity.parent);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", !ctx.entity.parent);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.addedEntitiesData.value == null ? null : ctx.addedEntitiesData.value.length) > 0 && !ctx.removeAllAddedInProgress);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", (ctx.addedEntitiesData.value == null ? null : ctx.addedEntitiesData.value.length) === 0 && !ctx.removeAllAddedInProgress);
          i0.ɵɵadvance();
          i0.ɵɵproperty("ngIf", ctx.removeAllAddedInProgress);
        }
      },
      dependencies: [i3.NgClass, i3.NgForOf, i3.NgIf, i1.NgControlStatus, i1.NgModel, i5.GridComponent, i6.CdkFixedSizeVirtualScroll, i6.CdkVirtualScrollViewport, i7.TextInputComponent, i8.MultiselectDropdownComponent, i9.SingleselectDropdownComponent, i10.OmnibarComponent, i10.OmnibarCustomContentComponent, i10.OmnibarFiltersComponent, i11.OverflowTooltipDirective, i12.SelectedTagsComponent, i13.TabsComponent, i13.TabComponent, i14.PopoverDirective, i15.SpinnerComponent, i3.AsyncPipe, i2$1.TranslationPipe, SearchFilterPipe],
      styles: [".cxone-add-entity{width:100%;height:100%}.cxone-add-entity>.content-wrapper{display:flex;padding:5px 10px;background-color:#eaf1f7;height:100%}.cxone-add-entity>.content-wrapper .button-wrapper{width:55px}.cxone-add-entity>.content-wrapper .button-wrapper .icon{display:inline-block;fill:#8fa1b3;height:18px;width:18px;cursor:pointer;position:relative;top:6px;left:-7px;margin:0 2px}.cxone-add-entity>.content-wrapper .button-wrapper .icon svg{pointer-events:none}.cxone-add-entity>.content-wrapper .button-wrapper .icon[hidden]{visibility:hidden}.cxone-add-entity>.content-wrapper .button-wrapper .icon:hover{fill:#adadad}.cxone-add-entity>.content-wrapper .left-section{width:70%;padding-right:20px}.cxone-add-entity>.content-wrapper .left-section .margin-x-small{margin:0 7.5px}.cxone-add-entity>.content-wrapper .left-section .flex-container{display:flex;align-items:center}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar .cxone-omnibar .content-wrapper .header-wrapper{padding-left:5px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar.filtersActive .filter-btn{background-color:#00d991!important;fill:#fff!important}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content{font-family:OpenSans;font-weight:400;font-size:13px;width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .vertical-line{width:1px;height:20px;margin:0 15px;background-color:#2e2e2e;transform:perspective(10px)}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .icon-wrapper{padding:10px 5px 10px 0;fill:#a3aebf}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .icon-wrapper .icon-btn{width:18px;height:18px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .count-wrapper .select-all-link{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .selected-filter-tags-wrapper{width:10%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper{margin-left:14px;min-width:40%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper cxone-text-input{width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]{height:35px;background-color:#fff;border:0}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]::placeholder{font-size:13px;color:#536f80}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]:focus{outline:auto;outline-color:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper{margin-left:-32px;height:30px;width:30px;background-color:#fff}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .icon{display:inline-block;height:18px;width:18px;place-items:center center;fill:#8fa1b3}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn{cursor:pointer;float:left;place-items:center center;left:6px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn{place-items:center center;float:right;left:-2px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper{margin:0 10px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn{width:35px;height:35px;padding:10px;cursor:pointer;pointer-events:all;box-sizing:border-box;border-radius:2px;background-color:#fff;box-shadow:0 1px 2px #1f324d33;fill:#a3aebf}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn svg{pointer-events:none}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .cxone-selected-tags{min-width:unset}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .movePush{margin-left:auto}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper{width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .dropdown-wrapper{float:left;width:250px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .dropdown-wrapper .filter-label{margin-bottom:6px;font-size:12px;font-weight:600;text-transform:uppercase;color:#5b7c8c}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .action-btns{float:right;margin-top:30px;margin-right:7px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .action-btns a{margin-left:7px;cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-wrapper{height:calc(100% - 60px)}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-wrapper .ag-row{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-with-filters-wrapper{height:calc(100% - 137px)}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-with-filters-wrapper .ag-row{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root{border:0!important}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header .ag-header-cell .ag-header-cell-text{margin-left:10px;width:100%;word-wrap:break-word}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body-viewport .ag-row .ag-cell{margin-left:10px;width:100%;height:100%;word-wrap:break-word}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body-viewport{max-height:100%;height:100%}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .checkBoxClass{left:9px!important}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .checkBoxClass label{top:3px}.cxone-add-entity>.content-wrapper .right-section{width:30%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs ul.bottom-row{max-height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .cdk-virtual-scroll-viewport{height:calc(100% - 20px)}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .cdk-virtual-scroll-content-wrapper{overflow:auto;min-height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header{width:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab{height:60px!important;width:50%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab .title-container{padding-top:18px!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab:nth-child(2) .separator{display:none!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-content{height:calc(100% - 58px)}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-content .active-tab{display:flex;background-color:#fafafa;flex-direction:column}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover{background-color:unset!important;border:0!important;box-shadow:none!important;width:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.top>.arrow{bottom:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.top>.arrow:after{border-top-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.bottom>.arrow{top:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.bottom>.arrow:after{border-bottom-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.left>.arrow{right:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.left>.arrow:after{border-left-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.right>.arrow{left:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.right>.arrow:after{border-right-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content{background-color:#373b3f;padding:14px;border:0!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .removal-msg{color:#fff}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .dropdown{margin-top:11px;margin-bottom:20px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .confirmBtns{display:flex;justify-content:flex-end}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .confirmBtns button{margin-left:10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .active-tab{padding:0;height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row{display:flex;align-items:center;padding:14px;border-bottom:1px solid rgb(208,210,211);background-color:#fff}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper{display:flex;align-items:center;margin-right:11px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper cxone-text-input{width:100%;min-width:220px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper cxone-text-input .cxone-text-input input{padding-right:30px;width:215px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper .button-wrapper{position:relative;left:-30px;bottom:4px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row.disabled{pointer-events:none;opacity:.5}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row a{cursor:pointer;font-size:13px;color:#007cbe;flex-shrink:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:80px;position:absolute;right:50px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row a.disabled{color:#adadad;pointer-events:none}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row{display:flex;align-items:center;background-color:#fff;padding:9px 16px;border-bottom:1px solid #dae2e8;min-height:36px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info{flex:1}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info .title-text,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info .title-text{font-size:13px;color:#2e2e2e;margin-bottom:4px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info .subtitle-text,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info .subtitle-text{font-size:11px;color:#2e2e2e}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon{cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon div,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon div{width:14px;height:14px;fill:#d0d2d3}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon div svg,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon div svg{pointer-events:none}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon:hover div,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon:hover div{fill:#adadad}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .no-rows{display:flex;justify-content:center;align-items:flex-start;padding-top:45px;color:#adadad;font-size:14px;flex:1}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .remove-all-spinner{display:flex;height:100%;justify-content:center;align-items:center}\n"],
      encapsulation: 2
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEntityComponent, [{
    type: Component,
    args: [{
      selector: 'cxone-add-entity',
      encapsulation: ViewEncapsulation.None,
      template: "<div class=\"cxone-add-entity\">\n  <div class=\"content-wrapper\">\n    <div class=\"left-section\">\n      <cxone-omnibar [customOmnibar]=\"true\" [showFooter]=\"showFilters\" [ngClass]=\"{ 'filtersActive': selectedTags?.length !== 0 }\">\n        <cxone-omnibar-custom-content>\n          <div class=\"custom-omnibar-wrapper flex-container\">\n            <div class=\"icon-wrapper\" *ngIf=\"entity.icon\">\n              <div class=\"icon-btn\" [innerHTML]=\"entity.icon\"></div>\n            </div>\n            <div class=\"count-wrapper flex-container\">\n              <div class=\"count\">{{ 'cxone-domain-components.addEntity.total' | translate : { count: dataSize } }} <span *ngIf=\"filterOperation?.length > 0\"> ({{'cxone-domain-components.addEntity.viewing' | translate}} {{gridApi.getDisplayedRowCount()}})</span></div>\n              <div class=\"vertical-line\"></div>\n              <div *ngIf=\"!multiSelectCheckbox\" class=\"select-all-link\">\n                <a (click)=\"selectAll()\">{{ 'cxone-domain-components.addEntity.selectAll' | translate }}<span *ngIf=\"filterOperation?.length > 0\"> ({{filterOperation}})</span></a>\n              </div>\n              <div *ngIf=\"multiSelectCheckbox\">\n                {{multiSelRows.length}} {{ 'cxone-domain-components.addEntity.selected' | translate }}\n              </div>\n            </div>\n            <div class=\"search-wrapper flex-container\">\n              <cxone-text-input [(ngModel)]=\"searchQuery\" [placeholder]=\"entity.omnibar.searchPlaceholderText\"\n                                (ngModelChange)=\"onSearchQueryChange(searchQuery)\" class=\"ng-valid ng-dirty ng-touched\">\n              </cxone-text-input>\n              <div class=\"button-wrapper \">\n                <div *ngIf=\"searchQuery && searchQuery?.length > 0\" class=\"icon clear-btn\" [innerHTML]=\"addEntityService.getIcon('icon-close')\"\n                     (click)=\"clearSearchField()\" [hidden]=\"!searchQuery || searchQuery?.length === 0\">\n                </div>\n                <div *ngIf=\"searchQuery === undefined || searchQuery?.length === 0 \" class=\"icon search-btn\" [innerHTML]=\"addEntityService.getIcon('icon-search')\"\n                     (click)=\"onSearchQueryChange(searchQuery)\"></div>\n              </div>\n            </div>\n            <div *ngIf=\"filterFeature\" class=\"filter-wrapper\">\n              <div class=\"icon filter-btn\" [innerHTML]=\"addEntityService.getIcon('icon-filter')\"\n                   (click)=\"toggleFilters()\"></div>\n            </div>\n            <div *ngIf=\"filterFeature\" class=\"selected-filter-tags-wrapper\">\n              <cxone-selected-tags [tagsSource]=\"selectedTags\" [removable]=\"true\" (tagDeleted)=\"onTagDeleted($event)\">\n              </cxone-selected-tags>\n            </div>\n            <div *ngIf=\"multiSelectCheckbox\" class=\"movePush\">\n              <button\n                class=\"cxone-btn btn-medium active-btn btn-secondary btn-bg-is-white\"\n                [disabled]=\"multiSelRows?.length === 0\" (click)=\"moveSelected()\">\n                {{ 'cxone-domain-components.addEntity.move' | translate }}\n              </button>\n            </div>\n          </div>\n        </cxone-omnibar-custom-content>\n        <cxone-omnibar-filters>\n          <div class=\"filters-wrapper\">\n            <div class=\"dropdown-wrapper\" *ngFor=\"let filter of entity.filters\">\n              <label class=\"filter-label\" [innerText]=\"filter.label\"></label>\n              <cxone-multiselect-dropdown [(ngModel)]=\"filterOptionsChosen[filter.id]\" [options]=\"filter.items\"\n                  [search]=\"filter.searchable\" [bulkOperations]=\"filter.bulkOperations\" [placeholder]=\"filter.placeholder\"\n          [sortKey]=\"filter.sortKey\" [sortOrder]=\"filter.sortOrder\" [maxSelectionLimit]=\"filter.maxSelectionLimit\"        (ngModelChange)=\"onFiltersSelectionChange()\" [maxItemsToDisplay]=\"filter.maxItemsToDisplay\" [enableInfiniteScroll]=\"filter.enableInfiniteScroll\"\n                  (onServerSideSearch)=\"filter.onSearch($event)\" [serverSideSearch]=\"filter.serverSideOptions\"\n                  (onLoadData)=\"filter.populateData()\">\n                </cxone-multiselect-dropdown>\n            </div>\n            <div class=\"action-btns\">\n              <a (click)=\"clearAll()\">{{ 'cxone-domain-components.addEntity.clearAll' | translate }}</a>\n              <a (click)=\"toggleFilters()\">{{ 'cxone-domain-components.addEntity.close' | translate }} </a>\n            </div>\n          </div>\n        </cxone-omnibar-filters>\n      </cxone-omnibar>\n      <div class=\"add-entity-grid-wrapper\">\n        <cxone-grid [columnDefs]=\"entity.columnDefs\" [gridOptions]=\"gridOptions\"></cxone-grid>\n      </div>\n    </div>\n    <div class=\"right-section\">\n      <cxone-tabs>\n        <cxone-tab\n          title=\"{{ 'cxone-domain-components.addEntity.selectedCount' | translate : { count: selectedEntities?.length } }}\">\n          <div class=\"top-row\">\n            <div class=\"search-wrapper\">\n              <cxone-text-input class=\"search-selected\"\n                placeholder=\"{{ 'cxone-domain-components.addEntity.placeholder.selected' | translate }}\"\n                #searchQuerySelected></cxone-text-input>\n              <div class=\"button-wrapper\">\n                <div class=\"icon clear-btn\"\n                  *ngIf=\"searchQuerySelected && searchQuerySelected.modelValue?.length > 0\"\n                  (click)=\"searchQuerySelected.modelValue=''\"\n                  [innerHTML]=\"addEntityService.getIcon('icon-close')\">\n                </div>\n                <div class=\"icon search-btn\"\n                  *ngIf=\"searchQuerySelected && searchQuerySelected.modelValue?.length === 0\"\n                   [innerHTML]=\"addEntityService.getIcon('icon-search')\">\n                </div>\n              </div>\n            </div>\n            <a (click)=\"removeAllSelected()\" cxoneOverflowTooltip\n              [ngClass]=\"{ 'disabled': selectedEntities?.length === 0 }\">{{ 'cxone-domain-components.addEntity.removeAll' | translate }}</a>\n          </div>\n          <ul class=\"bottom-row\" *ngIf=\"!removeAllSelectedInProgress\">\n            <li class=\"selected-row\"\n              *ngFor=\"let entityRow of selectedEntities | searchFilter:searchQuerySelected.modelValue:entity.searchFieldKey\">\n              <div class=\"entity-info\">\n                <div class=\"title-text\" [innerText]=\"entityRow[entity.selectedEntityTitleKey]\"></div>\n                <div class=\"subtitle-text\" *ngIf=\"entity.selectedEntitySubtitleKey\"\n                  [innerText]=\"entityRow[entity.selectedEntitySubtitleKey]\"></div>\n              </div>\n              <div class=\"remove-icon\" (click)=\"removeSelectedEntity(entityRow)\">\n                <div [innerHTML]=\"addEntityService.getIcon('icon-close')\"></div>\n              </div>\n            </li>\n          </ul>\n          <div class=\"no-rows\" *ngIf=\"selectedEntities?.length === 0 && !removeAllSelectedInProgress\">\n            <span [innerText]=\"entity.noEntitySelectedText\"></span>\n          </div>\n          <div class=\"remove-all-spinner\" *ngIf=\"removeAllSelectedInProgress\">\n            <cxone-spinner [isSpinner]=\"removeAllSelectedInProgress\"></cxone-spinner>\n          </div>\n        </cxone-tab>\n        <cxone-tab\n          title=\"{{ 'cxone-domain-components.addEntity.addedCount' | translate : { count: totalAddedEntities } }}\">\n          <div class=\"top-row\">\n            <div class=\"search-wrapper\">\n              <cxone-text-input class=\"search-added\"  [(ngModel)]=\"searchQueryAdded\" (ngModelChange)=\"onAddedSearchQueryChange(searchQueryAdded)\"\n                placeholder=\"{{ 'cxone-domain-components.addEntity.placeholder.added' | translate }}\" #addedSearchQuery>\n              </cxone-text-input>\n              <div class=\"button-wrapper \">\n                   <div class=\"icon clear-btn\"\n                        *ngIf=\"searchQueryAdded && searchQueryAdded.length > 0\"\n                        (click)=\"addedSearchQuery.modelValue=''; clearAddedSearchQuery()\"\n                        [innerHTML]=\"addEntityService.getIcon('icon-close')\">\n                   </div>\n                   <div class=\"icon search-btn\"\n                        *ngIf=\"!searchQueryAdded || searchQueryAdded.length === 0\"\n                        [innerHTML]=\"addEntityService.getIcon('icon-search')\">\n                   </div>\n              </div>\n            </div>\n            <a\n              *ngIf=\"entity.parent\"\n              cxoneOverflowTooltip\n              [ngClass]=\"{ 'disabled': totalAddedEntities === 0 }\"\n              [popover]=\"removeAllAddedEntityPopover\"\n              containerClass=\"removal-popover\"\n              placement=\"left\"\n              [adaptivePosition]=\"true\"\n              [outsideClick]=\"true\"\n              [popoverContext]=\"getRemoveAllPopoverContext(pop)\"\n              #pop=\"bs-popover\">\n              {{ 'cxone-domain-components.addEntity.removeAll' | translate }}\n            </a>\n            <a\n              *ngIf=\"!entity.parent\"\n              cxoneOverflowTooltip\n              [ngClass]=\"{ 'disabled': totalAddedEntities === 0 }\"\n              (click)=\"removeAllAdded()\">\n              {{ 'cxone-domain-components.addEntity.removeAll' | translate }}\n            </a>\n          </div>\n          <cdk-virtual-scroll-viewport itemSize=\"49\" minBufferPx=\"800\" maxBufferPx=\"800\" *ngIf=\"addedEntitiesData.value?.length > 0 && !removeAllAddedInProgress\"\n            (scrolledIndexChange)=\"onScroll($event)\" class=\"bottom-row\">\n            <li class=\"selected-row\" *ngFor=\"let entityRow of addedEntitiesData | async\">\n              <div class=\"entity-info\">\n                <div class=\"title-text\" [innerText]=\"entityRow[entity.selectedEntityTitleKey]\"></div>\n                <div class=\"subtitle-text\" *ngIf=\"entity.selectedEntitySubtitleKey\"\n                  [innerText]=\"entityRow[entity.selectedEntitySubtitleKey]\"></div>\n              </div>\n              <div class=\"remove-icon\" (click)=\"removeAddedEntity(entityRow)\" *ngIf=\"!entity.parent\">\n                <div [innerHTML]=\"addEntityService.getIcon('icon-close')\"></div>\n              </div>\n              <div class=\"remove-icon\" placement=\"bottom\" [popover]=\"removeAddedEntityPopover\" [outsideClick]=\"true\"\n                [popoverContext]=\"getPopoverContext(entityRow, pop)\" containerClass=\"removal-popover\" [adaptivePosition]=\"true\"\n                *ngIf=\"entity.parent\" #pop=\"bs-popover\">\n                <div [innerHTML]=\"addEntityService.getIcon('icon-close')\"></div>\n              </div>\n            </li>\n          </cdk-virtual-scroll-viewport>\n          <div class=\"no-rows\" *ngIf=\"addedEntitiesData.value?.length === 0 && !removeAllAddedInProgress\">\n            <span [innerText]=\"entity.noEntityAddedText\"></span>\n          </div>\n          <div class=\"remove-all-spinner\" *ngIf=\"removeAllAddedInProgress\">\n            <cxone-spinner [isSpinner]=\"removeAllAddedInProgress\"></cxone-spinner>\n          </div>\n        </cxone-tab>\n      </cxone-tabs>\n    </div>\n  </div>\n</div>\n\n<ng-template #removeAddedEntityPopover let-params=\"params\">\n  <div>\n    <span class=\"removal-msg\">{{entity.confirmationMsgForRemoval}}</span>\n    <div class=\"dropdown\">\n      <cxone-singleselect-dropdown id=\"parent_entity\" [(ngModel)]=\"params.selected\"\n        (ngModelChange)=\"onPopoverDropdownValueChanged($event)\" [options]=\"entity.parent.options\"\n        [label]=\"entity.parent.label\" [search]=\"false\" [sortKey]=\"'id'\">\n      </cxone-singleselect-dropdown>\n    </div>\n    <div class=\"confirmBtns\">\n      <button id=\"popup-cancel\" class=\"cxone-btn btn-secondary btn-sm\"\n        (click)=\"params.pop.hide()\">{{ 'cxone-domain-components.addEntity.popover.no' | translate }}</button>\n      <button id=\"popup-save\" class=\"cxone-btn btn-default btn-primary btn-sm\"\n        (click)=\"popoverRemoveFromAdded(params.data, params.pop)\">{{ 'cxone-domain-components.addEntity.popover.yes' | translate }}</button>\n    </div>\n  </div>\n</ng-template>\n\n<ng-template #removeAllAddedEntityPopover let-params=\"params\">\n  <div>\n    <span class=\"removal-msg\">{{entity.confirmationMsgForRemoval}}</span>\n    <div class=\"dropdown\">\n      <cxone-singleselect-dropdown id=\"parent_entity\" [(ngModel)]=\"params.selected\"\n        (ngModelChange)=\"onPopoverDropdownValueChanged($event)\" [options]=\"entity.parent.options\"\n        [label]=\"entity.parent.label\" [search]=\"false\" [sortKey]=\"'id'\">\n      </cxone-singleselect-dropdown>\n    </div>\n    <div class=\"confirmBtns\">\n      <button id=\"popup-cancel\" class=\"cxone-btn btn-secondary btn-sm\"\n        (click)=\"params.pop.hide()\">{{ 'cxone-domain-components.addEntity.popover.no' | translate }}</button>\n      <button id=\"popup-save\" class=\"cxone-btn btn-default btn-primary btn-sm\"\n        (click)=\"popoverRemoveAllFromAdded(params.pop)\">{{ 'cxone-domain-components.addEntity.popover.yes' | translate }}</button>\n    </div>\n  </div>\n</ng-template>",
      styles: [".cxone-add-entity{width:100%;height:100%}.cxone-add-entity>.content-wrapper{display:flex;padding:5px 10px;background-color:#eaf1f7;height:100%}.cxone-add-entity>.content-wrapper .button-wrapper{width:55px}.cxone-add-entity>.content-wrapper .button-wrapper .icon{display:inline-block;fill:#8fa1b3;height:18px;width:18px;cursor:pointer;position:relative;top:6px;left:-7px;margin:0 2px}.cxone-add-entity>.content-wrapper .button-wrapper .icon svg{pointer-events:none}.cxone-add-entity>.content-wrapper .button-wrapper .icon[hidden]{visibility:hidden}.cxone-add-entity>.content-wrapper .button-wrapper .icon:hover{fill:#adadad}.cxone-add-entity>.content-wrapper .left-section{width:70%;padding-right:20px}.cxone-add-entity>.content-wrapper .left-section .margin-x-small{margin:0 7.5px}.cxone-add-entity>.content-wrapper .left-section .flex-container{display:flex;align-items:center}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar .cxone-omnibar .content-wrapper .header-wrapper{padding-left:5px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar.filtersActive .filter-btn{background-color:#00d991!important;fill:#fff!important}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content{font-family:OpenSans;font-weight:400;font-size:13px;width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .vertical-line{width:1px;height:20px;margin:0 15px;background-color:#2e2e2e;transform:perspective(10px)}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .icon-wrapper{padding:10px 5px 10px 0;fill:#a3aebf}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .icon-wrapper .icon-btn{width:18px;height:18px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .count-wrapper .select-all-link{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .selected-filter-tags-wrapper{width:10%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper{margin-left:14px;min-width:40%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper cxone-text-input{width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]{height:35px;background-color:#fff;border:0}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]::placeholder{font-size:13px;color:#536f80}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper input[type=text]:focus{outline:auto;outline-color:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper{margin-left:-32px;height:30px;width:30px;background-color:#fff}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .icon{display:inline-block;height:18px;width:18px;place-items:center center;fill:#8fa1b3}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn{cursor:pointer;float:left;place-items:center center;left:6px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .clear-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn{place-items:center center;float:right;left:-2px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .search-wrapper .button-wrapper .search-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper{margin:0 10px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn{width:35px;height:35px;padding:10px;cursor:pointer;pointer-events:all;box-sizing:border-box;border-radius:2px;background-color:#fff;box-shadow:0 1px 2px #1f324d33;fill:#a3aebf}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn:hover{fill:#008fd8}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn:active{fill:#237bc2}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .filter-wrapper .filter-btn svg{pointer-events:none}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .cxone-selected-tags{min-width:unset}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-custom-content .custom-omnibar-wrapper .movePush{margin-left:auto}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper{width:100%}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .dropdown-wrapper{float:left;width:250px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .dropdown-wrapper .filter-label{margin-bottom:6px;font-size:12px;font-weight:600;text-transform:uppercase;color:#5b7c8c}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .action-btns{float:right;margin-top:30px;margin-right:7px}.cxone-add-entity>.content-wrapper .left-section cxone-omnibar cxone-omnibar-filters .filters-wrapper .action-btns a{margin-left:7px;cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-wrapper{height:calc(100% - 60px)}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-wrapper .ag-row{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-with-filters-wrapper{height:calc(100% - 137px)}.cxone-add-entity>.content-wrapper .left-section .add-entity-grid-with-filters-wrapper .ag-row{cursor:pointer}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root{border:0!important}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-header .ag-header-cell .ag-header-cell-text{margin-left:10px;width:100%;word-wrap:break-word}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body-viewport .ag-row .ag-cell{margin-left:10px;width:100%;height:100%;word-wrap:break-word}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .ag-body-viewport{max-height:100%;height:100%}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .checkBoxClass{left:9px!important}.cxone-add-entity>.content-wrapper .left-section .cxone-grid .ag-theme-balham .ag-root-wrapper .ag-root-wrapper-body .ag-root .checkBoxClass label{top:3px}.cxone-add-entity>.content-wrapper .right-section{width:30%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs ul.bottom-row{max-height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .cdk-virtual-scroll-viewport{height:calc(100% - 20px)}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .cdk-virtual-scroll-content-wrapper{overflow:auto;min-height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header{width:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab{height:60px!important;width:50%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab .title-container{padding-top:18px!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-header .upper-tab:nth-child(2) .separator{display:none!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-content{height:calc(100% - 58px)}.cxone-add-entity>.content-wrapper .right-section cxone-tabs .upper-tabs-content .active-tab{display:flex;background-color:#fafafa;flex-direction:column}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover{background-color:unset!important;border:0!important;box-shadow:none!important;width:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.top>.arrow{bottom:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.top>.arrow:after{border-top-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.bottom>.arrow{top:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.bottom>.arrow:after{border-bottom-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.left>.arrow{right:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.left>.arrow:after{border-left-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.right>.arrow{left:-10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover.right>.arrow:after{border-right-color:#373b3f}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content{background-color:#373b3f;padding:14px;border:0!important}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .removal-msg{color:#fff}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .dropdown{margin-top:11px;margin-bottom:20px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .confirmBtns{display:flex;justify-content:flex-end}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .removal-popover .popover-content .confirmBtns button{margin-left:10px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .active-tab{padding:0;height:100%}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row{display:flex;align-items:center;padding:14px;border-bottom:1px solid rgb(208,210,211);background-color:#fff}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper{display:flex;align-items:center;margin-right:11px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper cxone-text-input{width:100%;min-width:220px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper cxone-text-input .cxone-text-input input{padding-right:30px;width:215px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row .search-wrapper .button-wrapper{position:relative;left:-30px;bottom:4px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row.disabled{pointer-events:none;opacity:.5}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row a{cursor:pointer;font-size:13px;color:#007cbe;flex-shrink:0;text-overflow:ellipsis;overflow:hidden;white-space:nowrap;max-width:80px;position:absolute;right:50px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .top-row a.disabled{color:#adadad;pointer-events:none}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row{display:flex;align-items:center;background-color:#fff;padding:9px 16px;border-bottom:1px solid #dae2e8;min-height:36px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info{flex:1}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info .title-text,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info .title-text{font-size:13px;color:#2e2e2e;margin-bottom:4px}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .entity-info .subtitle-text,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .entity-info .subtitle-text{font-size:11px;color:#2e2e2e}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon{cursor:pointer;width:30px;height:30px;display:flex;align-items:center;justify-content:center}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon div,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon div{width:14px;height:14px;fill:#d0d2d3}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon div svg,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon div svg{pointer-events:none}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab ul.bottom-row li.selected-row .remove-icon:hover div,.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .cdk-virtual-scroll-viewport li.selected-row .remove-icon:hover div{fill:#adadad}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .no-rows{display:flex;justify-content:center;align-items:flex-start;padding-top:45px;color:#adadad;font-size:14px;flex:1}.cxone-add-entity>.content-wrapper .right-section cxone-tabs cxone-tab .remove-all-spinner{display:flex;height:100%;justify-content:center;align-items:center}\n"]
    }]
  }], () => [{
    type: AddEntityService
  }, {
    type: i2$1.TranslationPipe
  }], {
    entity: [{
      type: Input
    }],
    scrollers: [{
      type: ViewChildren,
      args: [CdkVirtualScrollViewport]
    }]
  });
})();
class AddEntityModule {
  /** @nocollapse */static {
    this.ɵfac = function AddEntityModule_Factory(t) {
      return new (t || AddEntityModule)();
    };
  }
  /** @nocollapse */
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: AddEntityModule
    });
  }
  /** @nocollapse */
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [CommonModule, FormsModule, GridModule, ScrollingModule, TextInputModule, MultiselectDropdownModule, SingleselectDropdownModule, OmnibarModule, OverflowTooltipModule, SelectedTagsModule, TabsModule, TranslationModule, PopoverModule.forRoot(), I18NextModule.forRoot(), SpinnerModule, CheckboxModule]
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(AddEntityModule, [{
    type: NgModule,
    args: [{
      declarations: [AddEntityComponent, SearchFilterPipe, SelectionHeaderCheckboxComponent],
      imports: [CommonModule, FormsModule, GridModule, ScrollingModule, TextInputModule, MultiselectDropdownModule, SingleselectDropdownModule, OmnibarModule, OverflowTooltipModule, SelectedTagsModule, TabsModule, TranslationModule, PopoverModule.forRoot(), I18NextModule.forRoot(), SpinnerModule, CheckboxModule],
      exports: [AddEntityComponent, SelectionHeaderCheckboxComponent],
      schemas: [CUSTOM_ELEMENTS_SCHEMA]
    }]
  }], null, null);
})();

/**
 * Generated bundle index. Do not edit.
 */

export { AddEntityComponent, AddEntityModule, SelectionHeaderCheckboxComponent };
